import {
  toLocalTime,
  tempConversion,
  formatSpirometry
} from "helpers/variables";
import { ReadingContextInterface } from "context/initialState/Readings";
import { ChangeEvent } from "react";
import { BodyProps } from "components/shared/SimpleGrid/SimpleGrid";
import moment from "moment";
import { READING_TYPES } from "helpers/appConstants";
const {
  bloodGlucose,
  bloodPressure,
  temperature,
  weight,
  heartRate,
  oxygenSaturation,
  spirometry,
  activity,
  sleep
} = READING_TYPES;

export const formatTableBody = (
  readingsArray: ReadingContextInterface[],
  action: (event: ChangeEvent<HTMLElement>) => void,
  units: string | undefined,
  listType: string
) => {
  let tableBody: BodyProps[] | any = [];
  const isHeartRateList = listType === heartRate.display;
  readingsArray
    .sort((a, b) => {
      return moment(a.measuredAt).unix() - moment(b.measuredAt).unix();
    })
    .reverse()
    .map((reading: ReadingContextInterface) => {
      switch (reading.type) {
        case bloodPressure.abbreviation:
          const bpCell = isHeartRateList
            ? [
                { content: toLocalTime(reading.measuredAt), align: "center" },
                { content: reading.metrics?.pulse + "", align: "center" },
                { content: bloodPressure.display, align: "center" }
              ]
            : [
                { content: toLocalTime(reading.measuredAt), align: "center" },
                { content: reading.metrics?.systolic + "", align: "center" },
                { content: reading.metrics?.diastolic + "", align: "center" },
                { content: reading.metrics?.pulse + "", align: "center" }
              ];
          if (reading.metrics?.systolic && reading.metrics?.diastolic) {
            tableBody.push({
              id: reading.id,
              cells: bpCell,
              action: action
            });
          }
          break;
        case bloodGlucose.abbreviation:
          if (reading.metrics?.glucose) {
            tableBody.push({
              id: reading.id,
              cells: [
                { content: toLocalTime(reading.measuredAt), align: "center" },
                { content: reading.metrics?.glucose + "", align: "center" },
                {
                  content: `${
                    reading.metrics?.meal ? reading.metrics?.meal + "" : "•"
                  }`,
                  align: "center"
                }
              ],
              action: action
            });
          }
          break;
        case heartRate.abbreviation:
          tableBody.push({
            id: reading.id,
            cells: [
              { content: toLocalTime(reading.measuredAt), align: "center" },
              { content: reading.metrics?.pulse, align: "center" },
              { content: heartRate.display, align: "center" }
            ],
            action: action
          });
          break;
        case oxygenSaturation.abbreviation:
          const spo2Cell = isHeartRateList
            ? [
                { content: toLocalTime(reading.measuredAt), align: "center" },
                { content: reading.metrics?.pulse + "", align: "center" },
                { content: oxygenSaturation.display, align: "center" }
              ]
            : [
                { content: toLocalTime(reading.measuredAt), align: "center" },
                { content: reading.metrics?.spo2 + "", align: "center" }
              ];
          if (reading.metrics?.spo2) {
            tableBody.push({
              id: reading.id,
              cells: spo2Cell,
              action: action
            });
          }
          break;
        case spirometry.abbreviation:
          const spirReading = formatSpirometry(reading);
          const FEV1 = Number(spirReading.FEV1);
          const FVC = Number(spirReading.FVC);
          if (spirReading && !isNaN(FEV1) && FVC > 0) {
            tableBody.push({
              id: reading.id,
              cells: [
                { content: toLocalTime(reading.measuredAt), align: "center" },
                { content: FVC, align: "center" },
                { content: FEV1, align: "center" },
                {
                  content: `${((FEV1 / FVC) * 100).toFixed(1)}%`,
                  align: "center"
                }
              ],
              action: action
            });
          }
          break;
        case temperature.abbreviation:
          if (reading.metrics?.temp) {
            tableBody.push({
              id: reading.id,
              cells: [
                { content: toLocalTime(reading.measuredAt), align: "center" },
                {
                  content:
                    tempConversion(reading.metrics?.temp || 0, units) + "",
                  align: "center"
                }
              ],
              action: action
            });
          }
          break;
        case weight.abbreviation:
          if (reading.metrics?.weight) {
            tableBody.push({
              id: reading.id,
              cells: [
                { content: toLocalTime(reading.measuredAt), align: "center" },
                { content: reading.metrics?.weight + "", align: "center" }
              ],
              action: action
            });
          }
          break;
        case activity.abbreviation:
          if (reading.metrics?.steps) {
            tableBody.push({
              id: reading.id,
              cells: [
                { content: toLocalTime(reading.measuredAt), align: "center" },
                { content: reading.metrics?.steps + "", align: "center" }
              ],
              action: action
            });
          }
          break;
        case sleep.abbreviation:
          if (reading.metrics?.sleep) {
            tableBody.push({
              id: reading.id,
              cells: [
                { content: toLocalTime(reading.measuredAt), align: "center" },
                { content: reading.metrics?.sleep + "", align: "center" }
              ],
              action: action
            });
          }
          break;
      }
    });
  return tableBody;
};
